<template>
  <div class="home-container">
    <myHeader />
    <Description :width="width" />
    <PortfolioContainer :width="width" />
    <ReciewsContainer />
  </div>
</template>

<script>
import myHeader from "./myHeader.vue";
import Description from "./Description.vue";
import PortfolioContainer from "./PortfolioContainer.vue";
import ReciewsContainer from "./ReciewsContainer.vue";

export default {
  name: "home",
  components: {
    myHeader,
    Description,
    PortfolioContainer,
    ReciewsContainer,
  },
};
</script>
